export class AvailableServiceDefinition {
  imageFileName: string
  isAvailable: boolean
  isVisible: boolean

  constructor(imageFileName: string, isAvailable: boolean, isVisible: boolean = true) {
    this.imageFileName = imageFileName
    this.isAvailable = isAvailable
    this.isVisible = isVisible
  }
}
